export default "__VITE_ASSET__D8DjuJv6__"